$(function(){

    $("#cart-products-count").on("click",function(e){

        e.preventDefault();

        $("body").addClass("cart-drawer-open");

    });

    $(".cart-close-btn").on("click",function(){

        $("body").removeClass("cart-drawer-open");

    });

});

